import * as React from "react";

function SvgPhone(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 25 42"
      {...props}
    >
      <g
        stroke="currentColor"
        strokeWidth={1.8}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
      >
        <path
          strokeLinejoin="round"
          d="M20.397 40.167H4.937a3.102 3.102 0 01-3.103-3.104V4.937a3.102 3.102 0 013.103-3.104h15.46A3.104 3.104 0 0123.5 4.937v32.126a3.104 3.104 0 01-3.103 3.104zM1.833 33.5H23.5"
        />
        <path d="M10.167 5.167h5" />
        <path strokeLinejoin="round" d="M11.833 36.833H13.5" />
      </g>
    </svg>
  );
}

export default SvgPhone;
